/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLegDto
 */
export interface CreateLegDto {
    /**
     * ID of the starting stop
     * @type {string}
     * @memberof CreateLegDto
     */
    fromStopId: string;
    /**
     * ID of the ending stop
     * @type {string}
     * @memberof CreateLegDto
     */
    toStopId: string;
    /**
     * Travel mode for this leg
     * @type {string}
     * @memberof CreateLegDto
     */
    travelMode?: CreateLegDtoTravelModeEnum;
    /**
     * Manual override for travel time in minutes
     * @type {number}
     * @memberof CreateLegDto
     */
    travelTimeMinutes?: number;
    /**
     * Manual override for distance in meters
     * @type {number}
     * @memberof CreateLegDto
     */
    distanceMeters?: number;
    /**
     * Additional notes for this leg
     * @type {string}
     * @memberof CreateLegDto
     */
    notes?: string;
    /**
     * Whether to calculate route and travel time using Mapbox (default: true)
     * @type {boolean}
     * @memberof CreateLegDto
     */
    calculateRoute?: boolean;
}


/**
 * @export
 */
export const CreateLegDtoTravelModeEnum = {
    Walking: 'WALKING',
    Driving: 'DRIVING',
    Cycling: 'CYCLING'
} as const;
export type CreateLegDtoTravelModeEnum = typeof CreateLegDtoTravelModeEnum[keyof typeof CreateLegDtoTravelModeEnum];


/**
 * Check if a given object implements the CreateLegDto interface.
 */
export function instanceOfCreateLegDto(value: object): value is CreateLegDto {
    if (!('fromStopId' in value) || value['fromStopId'] === undefined) return false;
    if (!('toStopId' in value) || value['toStopId'] === undefined) return false;
    return true;
}

export function CreateLegDtoFromJSON(json: any): CreateLegDto {
    return CreateLegDtoFromJSONTyped(json, false);
}

export function CreateLegDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLegDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fromStopId': json['fromStopId'],
        'toStopId': json['toStopId'],
        'travelMode': json['travelMode'] == null ? undefined : json['travelMode'],
        'travelTimeMinutes': json['travelTimeMinutes'] == null ? undefined : json['travelTimeMinutes'],
        'distanceMeters': json['distanceMeters'] == null ? undefined : json['distanceMeters'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'calculateRoute': json['calculateRoute'] == null ? undefined : json['calculateRoute'],
    };
}

  export function CreateLegDtoToJSON(json: any): CreateLegDto {
      return CreateLegDtoToJSONTyped(json, false);
  }

  export function CreateLegDtoToJSONTyped(value?: CreateLegDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromStopId': value['fromStopId'],
        'toStopId': value['toStopId'],
        'travelMode': value['travelMode'],
        'travelTimeMinutes': value['travelTimeMinutes'],
        'distanceMeters': value['distanceMeters'],
        'notes': value['notes'],
        'calculateRoute': value['calculateRoute'],
    };
}

